module.exports = __webpack_public_path__ + "static/media/vk.c25429a8.svg";